import moment from 'moment'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import Loader from '../../common/loader/Loader'
import { ReactComponent as MailIcon } from '../../../assets/images/common/icons/mail-icon.svg'
import classes from './InvitedTable.module.scss'
import React from 'react'


const InvitedTable = ({ students, onResendInvite }) => {

  if (!students) {
    return (
      <div className='h-100 d-flex align-items-center justify-content-center'>
        <Loader>Loading Invitations</Loader>
      </div>
    )
  }

  return (
    <div id='studentsTable' className={classes.table}>
      <div className={classes.gridTable} id='tableContent'>
        <div className={classNames(classes.col, classes.header, classes.firstColumn, classes.topLeft)}>
          <span className='font-weight-bold'>Students ({students?.length || 0})</span>
        </div>
        <div className={classNames(classes.col, classes.header)}>
          Invited On
        </div>
        <div className={classNames(classes.col, classes.header)}>
          Email
        </div>
        <div className={classNames(classes.col, classes.header)}>
          Invited By
        </div>
        <div className={classNames(classes.col, classes.header)}>
          Resend Invite
        </div>

        {students.map(student => (
          <div key={student.id} className={classNames(classes.row)}>
            <div
              className={classNames(classes.col, classes.firstColumn, classes.studentInfo)}
              title={`${student.firstName} ${student.lastName}`}
            >
              <p className='font-weight-bold m-0'>{student.firstName} {student.lastName}</p>
            </div>

            <div className={classNames(classes.col, classes.centeredCol)}>
              <span className='font-weight-bold'>{student.createdAt ? moment(student.createdAt).format('DD/MM/YYYY') : '-'}</span>
            </div>

            <div className={classNames(classes.col, classes.centeredCol)}>
              <span>{student.email || ''}</span>
            </div>

            <div className={classNames(classes.col, classes.centeredCol)}>
              <span className='font-weight-bold'>
                {student.inviter ? `${student.inviter.firstName} ${student.inviter.lastName}` : '-'}
              </span>
            </div>

            <div className={classNames(classes.col, classes.centeredCol)}>
              <button className={classes.resendInviteButton} onClick={() => onResendInvite(student.id)}>
                <MailIcon className={classes.contactIcon} />
                Resend Invite
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

InvitedTable.propTypes = {
  students: PropTypes.array,
  isLoading: PropTypes.bool,
  onResendInvite: PropTypes.func,
}

export default InvitedTable
